export default "__VITE_ASSET__LDKlb6Vv__"